document.body.addEventListener("click", function (event) {
  let swatch = event.target.closest(".card-swatch-body");

  if (!swatch) {
    return;
  }
  const newImageUrl = swatch.dataset.imageUrl;
  const variantId = swatch.dataset.variantId;

  const card = swatch.closest(".card");
  card.classList.add("selected");

  const swatches = card.querySelectorAll(".card-swatch-body");
  swatches.forEach((element) => {
    element.classList.remove("selected");
  });
  swatch.classList.add("selected");

  const thumbnail = card.querySelector(".thumbnail");
  if (thumbnail && thumbnail.hasAttribute("srcset")) {
    thumbnail.removeAttribute("srcset");
  }
  if (thumbnail && newImageUrl) {
    thumbnail.src = newImageUrl;
  }

  const thumbnailHover = card.querySelector(".thumbnail-hover");
  if (thumbnailHover) {
    thumbnailHover.parentNode.removeChild(thumbnailHover);
  }

  const anchor = card.querySelector("a");
  if (!anchor) {
    return;
  }
  let url = new URL(anchor.href);
  url.searchParams.set("variant", variantId);
  anchor.href = url.toString();
});
